// Strip query parameters that commonly carry secrets — auth/reset tokens,
// API keys, OAuth state — before persisting page_url to the server.
// UTM and click-id params are preserved (attribution is the whole point).
// leadsource_debug is stripped so the 64-char debug token is not stored
// in lead history even though it must remain readable on page load.
var SENSITIVE_QUERY_KEYS = /^(token|access_token|id_token|refresh_token|auth_token|api_key|apikey|key|secret|password|passwd|pwd|session|sessionid|sid|code|state|nonce|otp|verification|verify|reset|reset_token|reset_password_token|invite|invitation|share|signature|sig|hash|leadsource_debug)$/i;

export function sanitizeUrl(href) {
  if (!href) return '';
  try {
    var u = new URL(href);
    if (u.search) {
      var params = u.searchParams;
      var stripped = [];
      params.forEach(function (_v, k) {
        if (SENSITIVE_QUERY_KEYS.test(k)) stripped.push(k);
      });
      for (var i = 0; i < stripped.length; i++) params['delete'](stripped[i]);
      u.search = params.toString();
    }
    u.hash = '';
    return u.toString();
  } catch (e) {
    return href.split('?')[0].split('#')[0];
  }
}
